import Swiper from "SwiperLatest";
import { Navigation, Scrollbar } from "SwiperLatest/modules/index.mjs";
import { gsap } from "gsap";

if (document.body.classList.contains("home")) {
    const page = document.querySelector(".mv__innerPagesStick>span");
    const circles = document.querySelectorAll(".mv__innerPagesPage>span");
    const progress = {
        value: 0,
    };

    let mvSwiper = new Swiper(".mvSwiper", {
        speed: 1000,
        slidesPerView: "auto",
        loop: true,
        centeredSlides: true,
        spaceBetween:
            innerWidth > 1024
                ? innerWidth * (54 / 1728)
                : innerWidth * (16 / 393),
        initialSlide: 0,
    });

    mvSwiper.slideToLoop(0, 0);

    window.mvswiper = mvSwiper;

    const autoplayDur = 5;

    let autoplay = gsap.fromTo(
        progress,
        {
            value: 0,
        },
        {
            value: mvSwiper.slides.length - 0.0001,
            duration: mvSwiper.slides.length * autoplayDur,
            ease: "none",
            repeat: -1,
        }
    );

    window.progress = progress;

    mvSwiper.on("sliderMove", () => {
        if (autoplay) {
            autoplay.kill();
            autoplay = null;
        }
    });

    mvSwiper.on("tap", () => {
        if (autoplay) {
            autoplay.kill();
            autoplay = null;
        }
    });

    let isSliding = false;

    circles.forEach((c, index) => {
        c.addEventListener("click", () => {
            if (!isSliding) {
                isSliding = true;
                let trueIndex = index;

                mvSwiper.el
                    .querySelector(".swiper-slide-active")
                    .classList.add("zoomout");

                if (autoplay) {
                    autoplay.kill();
                    autoplay = null;
                }

                setTimeout(() => {
                    mvSwiper.slideToLoop(trueIndex);

                    mvSwiper.slides.forEach((slide) => {
                        slide.classList.remove("zoomout");
                    });

                    isSliding = false;
                }, 600);
            }
        });
    });

    let isChanging = false;

    const animate = () => {
        if (!autoplay) {
            progress.value = mvSwiper.realIndex;
        }

        const lineprogress =
            100 * (progress.value / (mvSwiper.slides.length - 1));

        page.style.width = `${Math.min(100, lineprogress)}%`;
        if (
            autoplay &&
            Math.floor(progress.value) !== mvSwiper.realIndex &&
            !isChanging
        ) {
            isChanging = true;
            autoplay.pause();
            mvSwiper.el
                .querySelector(".swiper-slide-active")
                .classList.add("zoomout");

            setTimeout(() => {
                mvSwiper.slideNext();
                // console.log("600 " + mvSwiper.realIndex);
                setTimeout(() => {
                    mvSwiper.slides.forEach((slide) => {
                        slide.classList.remove("zoomout");
                    });
                    // console.log("1200 " + mvSwiper.realIndex);

                    autoplay.play();
                    isChanging = false;
                }, 1200);
            }, 600);
        }

        circles.forEach((c, index) => {
            if (index <= progress.value) {
                c.classList.add("is-on");
            } else {
                c.classList.remove("is-on");
            }
        });

        requestAnimationFrame(animate);
    };

    animate();
}

let adSwiper = new Swiper(".adSwiper", {
    speed: 600,
    slidesPerView: "auto",
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize:
            innerWidth > 1024
                ? innerWidth * (378 / 1728)
                : innerWidth * (32 / 393),
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    modules: [Navigation, Scrollbar],
});

let recSwiper = new Swiper(".recSwiper", {
    speed: 600,
    slidesPerView: "auto",
});

let weSwiper = new Swiper(".weSwiper", {
    speed: 600,
    slidesPerView: "auto",
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    modules: [Navigation],
});

let mfsSwiper = new Swiper(".mfsSwiper", {
    speed: 600,
    slidesPerView: "auto",
    on: {
        init: function () {
            adjustSlideHeight(this);
        },
        slideChangeTransitionEnd: function () {
            adjustSlideHeight(this);
        },
        resize: function () {
            adjustSlideHeight(this);
        },
    },
});

function adjustSlideHeight(swiper) {
    swiper.slides.forEach(function (slide, index) {
        slide.style.height = ``;
    });

    let maxHeight = 0;
    swiper.slides.forEach(function (slide, index) {
        const slideHeight = slide.offsetHeight;
        if (slideHeight > maxHeight) {
            maxHeight = slideHeight;
        }
    });
    swiper.slides.forEach(function (slide, index) {
        slide.style.height = `${maxHeight}px`;
    });
}
